import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDevelopment = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.6 5.6H3.4C3.05 5.6 2.8 5.875 2.8 6.2V8.8H2.2C2.075 8.8 2 8.9 2 9V10.2C2 10.325 2.075 10.4 2.2 10.4H2.8V13C2.8 13.35 3.05 13.6 3.4 13.6H4.6C4.925 13.6 5.2 13.35 5.2 13V6.2C5.2 5.875 4.925 5.6 4.6 5.6ZM17.8 8.8H17.2V6.2C17.2 5.875 16.925 5.6 16.6 5.6H15.4C15.05 5.6 14.8 5.875 14.8 6.2V13C14.8 13.35 15.05 13.6 15.4 13.6H16.6C16.925 13.6 17.2 13.35 17.2 13V10.4H17.8C17.9 10.4 18 10.325 18 10.2V9C18 8.9 17.9 8.8 17.8 8.8ZM13.4 4H12.2C11.85 4 11.6 4.275 11.6 4.6V8.8H8.4V4.6C8.4 4.275 8.125 4 7.8 4H6.6C6.25 4 6 4.275 6 4.6V14.6C6 14.95 6.25 15.2 6.6 15.2H7.8C8.125 15.2 8.4 14.95 8.4 14.6V10.4H11.6V14.6C11.6 14.95 11.85 15.2 12.2 15.2H13.4C13.725 15.2 14 14.95 14 14.6V4.6C14 4.275 13.725 4 13.4 4Z",
		fill: "#31A2CE"
	})
});
export default SvgDevelopment;
